import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const ok = await Promise.race<boolean>([
    auth.ensureAuthenticated(),
    new Promise<boolean>((resolve) => setTimeout(() => resolve(false), 8000))
  ]).catch(() => false);
  if (ok === true) return true;

  return router.createUrlTree(['/login'], {
    queryParams: { next: state.url }
  });
};
